import videojs from 'video.js';

const DEFAULTS = {
    logInterval: 60,
    checkBufferInterval: 1,
    checkBufferDiff: 7,
};

const TS_REGEX = /(?<ts>[0-9]+)\.ts/;

class StateReporter extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        let options_ = videojs.mergeOptions({}, DEFAULTS, options);
        super(player, options_);

        let logInterval, checkBufferInterval;
        this.player.on('ready', () => {
            this.prevBufferLength = this.currentBufferLength;
            this.logState('initial');
            logInterval = setInterval(() => this.logState('periodic'), options_.logInterval * 1000);
            checkBufferInterval = setInterval(() => this.checkBuffer(options_.checkBufferDiff), options_.checkBufferInterval * 1000);
        });
        this.player.on('dispose', () => {
            clearInterval(logInterval);
            clearInterval(checkBufferInterval);
        });
    }

    logState(eventType) {
        let currState = this.currentState;
        let message = `Current player state: ${currState.playbackState}, current time buffered: ${!!currState.bufferLength ? 'yes' : 'no'}`;
        message += `, buffer duration: ${currState.bufferLength.toFixed(2)} seconds`;
        message += `, current ts: ${currState.fragTimestamp}`;
        this._logMessage(eventType, message);
    }

    checkBuffer(checkBufferDiff) {
        let currentBufferLength = this.currentBufferLength;
        if (Math.abs(currentBufferLength - this.prevBufferLength) >= checkBufferDiff) {
            this._logMessage('bufChange', `Previous buffer length was: ${this.prevBufferLength.toFixed(2)}`);
            this.prevBufferLength = currentBufferLength;
            this.logState('bufChange');
        }
    }

    _logMessage(eventType, message) {
        console.log(`[StateReporter][${eventType}][${new Date().toLocaleString()}] ${message}`);
    }

    get currentState() {
        let currState = {};
        let currentFragTimestamp = this.currentFragTimestamp;
        currState.bufferLength = this.currentBufferLength;
        currState.playbackState = currentFragTimestamp ? (this.player.paused() ? 'paused' : 'playing') : 'paused';
        currState.fragTimestamp = this.currentFragTimestamp;
        return currState;
    }

    get currentBufferLength() {
        const hls = this.player.hls_;
        if (!hls || !hls.media || !hls.media.buffered) return 0;

        let timeRanges = [];
        for (let i = 0; i < hls.media.buffered.length; i++) {
            timeRanges.push({
                start: hls.media.buffered.start(i),
                end: hls.media.buffered.end(i)
            });
        }

        let currPos = hls.media.currentTime;
        let currRange = timeRanges.sort(
            (a, b) => a.start - b.start ? a.start - b.start : b.end - a.end
        ).find(range => currPos >= range.start && currPos <= range.end);

        return currRange ? currRange.end - currPos : 0;
    }

    get currentFragTimestamp() {
        const hls = this.player.hls_;
        const fragPlaying = hls && hls.streamController && hls.streamController.fragPlaying;
        const fragUrl = (fragPlaying && fragPlaying.url || '');
        if (fragUrl) {
            const testResult = fragUrl.match(TS_REGEX);
            return testResult && testResult.groups && testResult.groups.ts;
        }
    }
}
  
videojs.registerPlugin('stateReporter', StateReporter);
